export class fraction{
    numenator: number = 0
    denominator: number = 0
}